const C_PATH_ROUTER = {
  REALESTATE: {
    ROOT: "/realestates",
    LIST: "",
    DETAIL: "/detail/:id",
    DETAIL_SHORT: "/:id",
    CREATE: "/create",
    UPDATE: "/editar/:id",
    PROJECT_CREATE: "/project/create",
    PROJECT_UPDATE: "/project/editar/:id",
    RESOLVE_CONFLICT: "/conflicts/resolve/:id"
  },
  PROPERTIES: {
    ROOT: "/properties",
    LIST: "",
    DETAIL: "/detail/:id",
    DETAIL_SHORT: "/:id",
    CREATE: "/create",
    UPDATE: "/editar/:id",
    PROJECT_CREATE: "/project/create",
    PROJECT_UPDATE: "/project/editar/:id",
    RESOLVE_CONFLICT: "/conflicts/resolve/:id",
    DRAFT_LIST: "/drafts",
    DRAFT_UPDATE: "/borrador/:idDraft/editar",
    DRAFT_PROJECT_UPDATE: "/project/borrador/:idDraft/editar"
  },

  USERS: {
    ROOT: "/user",
    LIST: "",
    DETAIL: "/:id",
    CREATE: "/create",
    UPDATE: "/editar/:id"
  },
  MORTGAGE_REFERRAL: {
    ROOT: "/mortgage-reference",
    LIST: "/list",
    // DETAIL: "/:id",
    CREATE: "/create"
    // UPDATE: "/editar/:id",
  },
  BIBLIO: {
    ROOT: "/components"
  },
  OWNERS: {
    ROOT: "/owners",
    DETAIL: "/detail/:id",
    COMMON_DETAIL: "/common-detail",
    EDIT: "/edit/:id"
  },
  AGENCIES: {
    ROOT: "/agencies",
    LIST: "",
    CREATE: "/create",
    DETAIL: "/:id",
    EDIT: "/edit/:id"
  },
  APP_MOBILE: {
    ROOT: "/app-movil",
    PROMO: "/promo"
  }
};

const C_PATH_ROUTES = {
  REALESTATE: {
    LIST: `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.LIST}`,
    DETAIL: (ID: number | string) =>
      `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.DETAIL.replace(
        ":id",
        ID.toString()
      )}`,
    DETAIL_SHORT: (ID: number | string) =>
      `${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.REALESTATE.DETAIL_SHORT.replace(":id", ID.toString())}`,

    CREATE: `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.CREATE}`,
    UPDATE: (ID: number) =>
      `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.UPDATE.replace(
        ":id",
        ID.toString()
      )}`,
    DRAFT_LIST: `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.PROPERTIES.DRAFT_LIST}`,
    DRAFT_UPDATE: (ID: number) =>
      `${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_UPDATE.replace(":idDraft", ID.toString())}`,
    DRAFT_PROJECT_UPDATE: (ID: number) =>
      `${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_PROJECT_UPDATE.replace(
        ":idDraft",
        ID.toString()
      )}`,
    PROJECT_CREATE: `${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.PROJECT_CREATE}`,
    PROJECT_UPDATE: (ID: number | string) =>
      `${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.REALESTATE.PROJECT_UPDATE.replace(":id", ID.toString())}`,
    RESOLVE_CONFLICT: (ID: number) =>
      `${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.REALESTATE.RESOLVE_CONFLICT.replace(":id", ID.toString())}`
  },
  USERS: {
    LIST: `${C_PATH_ROUTER.USERS.ROOT}${C_PATH_ROUTER.USERS.LIST}`,
    DETAIL: `${C_PATH_ROUTER.USERS.ROOT}${C_PATH_ROUTER.USERS.DETAIL}`,
    CREATE: `${C_PATH_ROUTER.USERS.ROOT}${C_PATH_ROUTER.USERS.CREATE}`,
    UPDATE: `${C_PATH_ROUTER.USERS.ROOT}${C_PATH_ROUTER.USERS.UPDATE}`
  },
  BIBLIO: {
    LIST: `${C_PATH_ROUTER.BIBLIO.ROOT}`
  },
  MORTGAGE_REFERRAL: {
    LIST: `${C_PATH_ROUTER.MORTGAGE_REFERRAL.ROOT}${C_PATH_ROUTER.MORTGAGE_REFERRAL.LIST}`,
    CREATE: `${C_PATH_ROUTER.MORTGAGE_REFERRAL.ROOT}${C_PATH_ROUTER.MORTGAGE_REFERRAL.CREATE}`
  },
  OWNERS: {
    DETAIL: (ID: number) =>
      `${C_PATH_ROUTER.OWNERS.ROOT}${C_PATH_ROUTER.OWNERS.DETAIL.replace(
        ":id",
        ID.toString()
      )}`,
    EDIT: (ID: number) =>
      `${C_PATH_ROUTER.OWNERS.ROOT}${C_PATH_ROUTER.OWNERS.EDIT.replace(
        ":id",
        ID.toString()
      )}`
  },
  AGENCIES: {
    LIST: `${C_PATH_ROUTER.AGENCIES.ROOT}${C_PATH_ROUTER.AGENCIES.LIST}`,
    CREATE: `${C_PATH_ROUTER.AGENCIES.ROOT}${C_PATH_ROUTER.AGENCIES.CREATE}`,
    DETAIL: (ID: string | number) =>
      `${C_PATH_ROUTER.AGENCIES.ROOT}${C_PATH_ROUTER.AGENCIES.DETAIL.replace(
        ":id",
        ID.toString()
      )}`,
    EDIT: (ID: number | string) =>
      `${C_PATH_ROUTER.AGENCIES.ROOT}${C_PATH_ROUTER.AGENCIES.EDIT.replace(
        ":id",
        ID.toString()
      )}`
  },

  PROPERTIES: {
    LIST: [C_PATH_ROUTER.PROPERTIES.ROOT].join("/"),
    DETAIL: (ID: string) =>
      [
        C_PATH_ROUTER.PROPERTIES.ROOT,
        C_PATH_ROUTER.PROPERTIES.DETAIL.replace(":id", ID)
      ].join("/"),
    CREATE: [C_PATH_ROUTER.PROPERTIES.ROOT, C_PATH_ROUTER.PROPERTIES.CREATE].join(
      "/"
    ),
    UPDATE: (ID: string) =>
      [
        C_PATH_ROUTER.PROPERTIES.ROOT,
        C_PATH_ROUTER.PROPERTIES.UPDATE.replace(":id", ID)
      ].join("/")
  }
};

export { C_PATH_ROUTER, C_PATH_ROUTES };
